import React from "react"
import FAQs from "@views/faqs"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - FAQs"
      keywords={[
        `engineid`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <FAQs />
  </div>
)

export default IndexPage
